import { TicketNode } from "../../../../../../queries/types";
import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
  userDetails,
} from "../../../../../../utils/commonQueryTypes";
import { TicketStatus } from "../../../../../../utils/constants";
import { PriorityEnum } from "../../../../../../utils/Enum.types";
import {
  AtsCompany,
  TableType,
} from "../../../../customer/companies/queries/types";
import { PageInfo } from "../../../../customer/settings/predefinedList/queries/types";
import { AtsTicketDetails } from "../../../maps/queries/types";
import { AtsStckCategory } from "../../category/queries/types";
import {
  Junction,
  JunctionEdge,
} from "../../subsidary/junctions/queries/types";
import {
  AtsSubsidiary,
  AtsSubsidiarySite,
} from "../../subsidary/queries/types";
import { AtsAcLdgr } from "../../supplier/queries/types";

export enum AtsStckItemOrderField {
  CREATED_AT = "CREATED_AT",
  DESC = "DESC",
}

export enum AtsStckCompanyItemLdgrOrderField {
  CREATED_AT = "CREATED_AT",
}

export enum ItemQueryType {
  All = "ALL",
  ITEMS_ASSOIC_LDGR = "ITEMS_ASSOIC_LDGR",
  ITEMS_NOT_ASSOIC_LDGR = "ITEMS_NOT_ASSOIC_LDGR",
}

export enum ItemDetailsQueryType {
  ALL = "ALL",
  DETAILS_BY_ITEM_ID = "DETAILS_BY_ITEM_ID",
  GEO_ENABLED = "GEO_ENABLED",
  TO_CREATE_MODULE = "TO_CREATE_MODULE"
}
export interface ItemQueryData {
  query_type: ItemQueryType;
  stckCategoryID: number;
  stckGroupID: number;
  stckManufacturerID: number;
  stckUomID: number;
  stckSubCategoryID: number;
  ldgrID: number;
  subsidiaryID: number;
  isComponent: boolean | undefined;
  empID?: number;
}

export interface GetItemsVars extends commonPaginationTypes {
  customerID: number;
  companyID: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsStckItemOrderField;
  };
  input: ItemQueryData;
  name: string;
  hsnCode: string;
}

export interface AtsStckItem {
  id: number;
  desc: string;
  icon: string;
  slNo: number;
  code: string;
  uom: string;
  enableGst: boolean;
  prodModel: string;
  igst: number;
  sgst: number;
  cgst: number;
  isStockOrService: string;
  trackSerial: boolean;
  trackBatch: boolean;
  trackExpiry: boolean;
  trackWarranty: boolean;
  trackInstallation: boolean;
  trackMaintenance: boolean;
  isPerishable: boolean;
  isConsumable: boolean;
  imageNeeded: boolean;
  trackAmc: boolean;
  trackGeoLocation: boolean;
  trackInsurance: boolean;
  trackCalibration: boolean;
  isModule: boolean;
  isComponent: boolean;
  image_path: string;
  customerID: number;
  stckCategoryID: number;
  stckGroupID: number;
  stckManufacturerID: number;
  stckUomID: number;
  categoryDetails: {
    categoryName: string;
  };

  groupDetails: {
    groupName: string;
  };
  manufacturerDetails: {
    manufacturer: string;
  };
  uomDetails: {
    uom: string;
    uomDesc: string;
  };
  subCategoryDetails: {
    subCategoryName: string;
  };
  additionalPropertyNeeded: boolean;
  noOfAdditionalProperties: number;
  AdditionalPropertyDesc1: string;
  AdditionalPropertyDesc2: string;
  AdditionalPropertyDesc3: string;
  AdditionalPropertyDesc4: string;
  AdditionalPropertyDesc5: string;
  AdditionalPropertyDesc6: string;
  AdditionalPropertyDesc7: string;
  AdditionalPropertyDesc8: string;
  AdditionalPropertyDesc9: string;
  AdditionalPropertyDesc10: string;
  AdditionalPropertyDatatype1: string;
  AdditionalPropertyDatatype2: string;
  AdditionalPropertyDatatype3: string;
  AdditionalPropertyDatatype4: string;
  AdditionalPropertyDatatype5: string;
  AdditionalPropertyDatatype6: string;
  AdditionalPropertyDatatype7: string;
  AdditionalPropertyDatatype8: string;
  AdditionalPropertyDatatype9: string;
  AdditionalPropertyDatatype10: string;
  stckDetailsEntryIsMultiple: boolean;
  inStockDetails: AtsStckCompanyItemLdgr;
  ldgr_count: number;
  hsnCode: string;
  trackBrand: boolean;
  trackModel: boolean;
}

export interface AtsStckItemEdge {
  node: AtsStckItem;
  cursor: string;
}

interface GetItemsData {
  edges: AtsStckItemEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetItemsResult {
  GetItems: GetItemsData;
}

//Mutations

export interface CreateAtsStckItemInput {
  desc: string;
  code: string;
  uom: string;
  enableGst: boolean;
  igst: number;
  sgst: number;
  cgst: number;
  isStockOrService: string;
  trackSerial: boolean;
  trackBatch: boolean;
  trackExpiry: boolean;
  trackWarranty: boolean;
  trackInstallation: boolean;
  trackMaintenance: boolean;
  isPerishable: boolean;
  isConsumable: boolean;
  imageNeeded: boolean;
  trackAmc: boolean;
  trackGeoLocation: boolean;
  trackInsurance: boolean;
  trackCalibration: boolean;
  isModule: boolean;
  isComponent: boolean;
  image_path: string;
  stckCategoryID: number;
  stckGroupID: number;
  stckManufacturerID: number;
  stckUomID: number;
}

export interface AddItemVar extends commonMutationTypes {
  input: CreateAtsStckItemInput;
  customer_id: number;
}

export interface AddItemResult {
  AddItem: boolean;
}

export interface UpdateItemVar extends commonMutationTypes {
  input: CreateAtsStckItemInput;
  item_id: number;
}

export interface UpdateItemResult {
  UpdateItem: boolean;
}

export interface DeleteItemByIdResult {
  DeleteItem: boolean;
}

export interface DeleteItemByIdVars extends commonMutationTypes {
  item_id: number;
}

export interface GetItemDescByNodeIdResult {
  node: {
    id: number;
    desc: string;
    code: string;
  };
}

export interface filterDataType {
  ItemGroupId: number;
  ItemCategoryId: number;
  UoMId: number;
}
export interface filterDataTypeForAsset {
  CompanyID: number;
  SubsidiaryID: number;
  SiteID: number;
  junctionID: number;
}
export interface AtsStckCompanyItemLdgr {
  id: number;
  stkOb: string;
  stkObRate: number;
  item: AtsStckItem;
}

export interface AtsStckCompanyItemLdgrEdge {
  node: AtsStckCompanyItemLdgr;
  cursor: string;
}

export interface GetStockCompanyItemLdgrResult {
  GetStockCompanyItemLdgr: {
    edges: AtsStckCompanyItemLdgrEdge[];
    pageInfo: pageInfo;
    totalCount: number;
  };
}

export interface GetStockCompanyItemLdgrVar {
  token: string;
  after: string | null;
  first: number | null;
  customerID: number;
  companyID: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsStckCompanyItemLdgrOrderField;
  };
  input: ItemQueryData;
  name: string;
  hsnCode: string;
}

interface ItemDetailsQuery {
  query_type: ItemDetailsQueryType;
  stckCategoryID: number;
  stckGroupID: number;
  stckManufacturerID: number;
  stckUomID: number;
  stckSubCategoryID: number;
  ldgrID: number;
  itemID: number;
  empID: number;
  poleNum?: number | null;
  onlyAlcoMeters?: boolean;
}

export const enum AtsStckItemDetailsOrderField {
  CREATED_AT = "CREATED_AT",
}
interface AtsStckItemDetailsOrder {
  direction: OrderDirection;
  field: AtsStckItemDetailsOrderField;
}

export interface GetItemsDetailsVars extends commonPaginationTypes {
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  junctionID: number;
  input: ItemDetailsQuery;
  name: string;
  orderBy: AtsStckItemDetailsOrder;
}

export interface AtsStckItemDetails {
  id: number; // Unique identifier for the item
  prodBrand: string;
  item: AtsStckItem;
  prodSerialNo: string;
  prodBatchNo: string;
  prodExpiryDate: string;
  prodWarrantyStartDate: string;
  prodWarrantyEndDate: string;
  prodAmcStDate: string;
  prodAmcEndDate: string;
  prodInsuranceStDate: string;
  prodInsuranceEndDate: string;
  prodLatitude: string;
  prodLongitude: string;
  prodInstallationEndDate: string;
  prodModel: string;
  currentCompany: AtsCompany;
  currentSubsidiary: AtsSubsidiary;
  currentJunction: Junction;
  ticketStatus: TicketStatus;
  currentSite: AtsSubsidiarySite;
  vendorDetails: AtsAcLdgr;
  calibrationCount: number;
  currentBlowCount: number;
  ldgrID: number;
  poleNum: number;
  curCompanyID: number;
  initialJunction: {
    id: number;
    ldgrID: number;
  };
}

export interface ItemOrSiteNode {
  id: number;
  prodSerialNo: string;
  prodBatchNo: string;
  prodExpiryDate: string;
  prodWarrantyStartDate: string;
  prodWarrantyEndDate: string;
  prodLatitude: string;
  prodLongitude: string;
  prodInstallationEndDate: string;
  item: {
    id: number;
    desc: string;
    code: string;
    icon: string;
    uom: string;
    categoryDetails: AtsStckCategory;
    enableGst: boolean;
  };
  currentCompany: {
    id: number;
    name: string;
    address: string;
    place: string;
  };
  currentSubsidiary: {
    id: number;
    name: string;
    place: string;
  };

  name: string;
  address: string;
  company: {
    id: number;
    name: string;
    address: string;
    place: string;
  };
  subsidiary: {
    id: number;
    name: string;
    place: string;
  };
}

interface AtsStckItemDetailsConnection {
  edges: AtsStckItemDetailsEdges[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface GetItemsDetailsResult {
  GetItemsDetails: AtsStckItemDetailsConnection;
}

export interface GetTicketDetailsVars {
  token?: string;
  customerID: number;
  ticketID: number;
}

export interface TicketDetails {
  id: number;
  slNo: string;
  attendedDate: string;
  completed: boolean;
  anyChanges: boolean;
  anySparesChanged: boolean;
  status: string;
  remarks: string;
  attendedByID: number;
  escaltedToID: number;
  customerID: number;
  companyID: number;
  itemID: number;
  itemDetailsID: number;
  siteID: number;
  ticketID: number;
  ticket: TicketNode;
  ticketNo: string;
  ticketDate: string;
  reason: string;
  type: string;
  junctionID: number;
  imagesPath: string;
}

export interface InputTicketDetails {
  ticketDate: string;
  reason: string;
  type: string;
  remarks: String;
  imagesPath: string;
  itemDetailsID: number;
  siteID: number;
  junctionID: number;

  poleNum: number;
  tableLevel: TableType;
}

export interface GetTicketDetailsResult {
  GetTicketDetails: AtsTicketDetails[];
}

export interface TicketDetailsInput {
  status: string;
  remarks: string;
  imagesPath: string;
  assignedID: number;
}

export interface TicketAssetsInput {
  itemDetailsID: number;
  anyChanges: string;
  AnySparesChanged: string;
  remarks: string;
  imagesPath: string;
}

export interface DeviceTypes {
  deviceTypeID: number;
  deviceName: string;
  numOfUnits: number | null;
}

export interface AddTicketDetailsVariables {
  token?: string;
  todaysDate: string;
  customerID: number;
  ticketID: number;
  input: TicketDetailsInput;
  assetDetails: TicketAssetsInput[];
  deviceTypes: DeviceTypes[];
  user_details: userDetails;
}

export interface AddTicketDetailsResult {
  AddTicketDetails: AtsTicketDetails;
}

export interface AtsTicketsForTicketDetailsByNodeType {
  id: number;
  attendedDate: string;
  remarks: string;
  status: string;
  imagesPath: string;
  companyID: number;
  ticketID: number;
  itemDetails: AtsStckItemDetails;
}

export interface AtsTicketsForTicketDetailsByNodeData {
  node: {
    ticketDetails: AtsTicketsForTicketDetailsByNodeType[];
  };
}

export interface AtsStckItemDetailsNode {
  id: number;
  prodSerialNo: string;
  prodLatitude: number;
  prodLongitude: number;
  item: AtsStckItem;
  ticketStatus: TicketStatus;
  currentCompany: AtsCompany;
  currentSubsidiary: AtsSubsidiary;
  currentSite: AtsSubsidiarySite;
  currentJunction: Junction;
  calibrationCount: number;
  currentBlowCount: number;
  curCompanyID: number;
  prodBatchNo: string;
  prodExpiryDate: string;
  prodBrand: string;
  prodModel: string;
  prodWarrantyStartDate: string;
  prodWarrantyEndDate: string;
  prodAmcStDate: string;
  prodAmcEndDate: string;
  prodInsuranceStDate: string;
  prodInsuranceEndDate: string;
  poleNum: number;
  vendorDetails: AtsAcLdgr;
  blow_count: number;
  address: string;
  ldgrID: number;
}

export interface AtsStckItemDetailsEdges {
  node: AtsStckItemDetailsNode;
}

export interface GetItemsDetailsForMapData {
  GetItemsDetailsForMap: AtsStckItemDetailsNode[];
}

export interface GetItemsDetailsForMapVars {
  token: string;
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  junctionID: number;
  empID: number;
  ticketStatus: TicketStatus[];
}

export interface GetDataForMapsResult {
  companyID: number;
  id: number;
  icon: string;
  name: string;
  latitude: string;
  longitude: string;
  ticketStatus: TicketStatus;
  prodSerialNo: string;
  desc: string;
  address: string;
}
export interface GetDataForMapsData {
  GetDataForMaps: GetDataForMapsResult[];
}

export interface GetDataForMapsVars {
  token?: string;
  customerID: number;
  input: {
    retTableType: TableType;
    idType: TableType;
    id: number;
    empID: number;
    ticketStatus: TicketStatus[];
    priority: PriorityEnum[];
    jType: string[];
    LdgrIds: number[];
    itemID: number;
  };
}

export interface GetCompOrJuncOrAssetOrSubAndSiteNodeResult {
  id: number;
  name: string;
  jType: string;
  arms: number;
  latitude: number;
  longitude: number;
  priority: string;
  code: string;
  prodSerialNo: string;
  prodLatitude: number;
  prodLongitude: number;
  prodExpiryDate: string;
  prodWarrantyEndDate: string;
  prodInstallationEndDate: string;
  prodBatchNo: string;
  currentCompany: AtsCompany;
  poles: number;
  icon: string;
  status: string;
  companyID: number;
  curCompanyID: number;
  currentSite: AtsSubsidiarySite;
  subsidiary: AtsSubsidiary;
  item: {
    id: number;
    icon: string;
    code: string;
    desc: string;
  };
  vendorDetails: {
    desc: string;
  };
  currentSubsidiary: AtsSubsidiary;
  site: {
    name: string;
  };
}

export interface GetCompOrJuncOrAssetOrSubAndSiteNodeVars {
  token?: string;
  id: number;
}

export interface GetJunctionTypesVars {
  token?: string;
  customerID: number;
}

export interface GetJunctionTypesResult {
  GetJunctionTypes: string[];
}

export interface calibrationData {
  blowCount: number;
  itemDetailsID: number;
}

export interface AddBlowCountVars {
  customerID: number;
  todaysDate: string;
  input: calibrationData[];
  user_details: userDetails;
}

export interface AddBlowCountResult {
  AddBlowCount: boolean;
}

export enum AtsCalibrationDetailsOrderField {
  CREATED_AT = "CREATED_AT",
}

export interface GetCalibrationDetailsVars {
  itemDetailsID: number;
  itemID: number;
  empID: number;
  customer_id: number;
  after: string | null;
  todaysDate?: string;
  first: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsCalibrationDetailsOrderField;
  };
  name: string;
}

export interface AtsCalibrationDetails {
  id: number;
  blowDate: string;
  blowCount: number;
  itemDetails: AtsStckItemDetails;
  checked: boolean;
  blow_count: number;
}

export interface AtsCalibrationDetailsEdge {
  node: AtsCalibrationDetails;
}

export interface GetCalibrationDetailsResult {
  GetCalibrationDetails: {
    edges: AtsCalibrationDetailsEdge[];
    pageInfo: PageInfo;
    totalCount: number;
  };
}

export interface GetBlowCountDetailsResult {
  GetBlowCountDetails: {
    edges: AtsCalibrationDetailsEdge[];
    pageInfo: PageInfo;
    totalCount: number;
  };
}

export interface GetBlowCountDetailsVars extends GetCalibrationDetailsVars {}

export interface GetAlcometerDetailVars {
  customerID: number;
}

export interface GetAlcometerDetailResult {
  GetAlcometerDetail: {
    id: number;
    desc: string;
    code: string;
  };
}

export type UnifiedItem = AtsCalibrationDetailsEdge | AtsStckItemDetailsEdges;

export interface AddCalibrateVars {
  customerID: number;
  itemDetailsID: number;
  todaysDate: string;
  user_details: userDetails;
}

export interface AddCalibrateResult {
  AddCalibrate: boolean;
}

export interface UpdateCalibrationData {
  blowCount: number;
  calibrationID: number;
}

export interface UpdateBlowCountVars {
  customerID: number;
  input: UpdateCalibrationData[];
  user_details: userDetails;
}

export interface UpdateBlowCountResult {
  UpdateBlowCount: boolean;
}

export interface DeleteItemDetailsVar {
  token?: string;
  customerID: number;
  itemDetailsID: number;
  user_details: userDetails;
}

export interface DeleteItemDetailsResult {
  DeleteItemDetails: boolean;
}

export interface MoveItemDetailsResult {
  MoveItemDetails: boolean;
}

export interface MoveItemDetailsInput {
  itemDetailsID: number;
  curCompanyID: number;
  curSubsidiaryID: number;
  curSiteID: number;
  curJunctionID: number;
}

export interface MoveItemDetailsVar extends commonMutationTypes {
  customerID: number;
  input: MoveItemDetailsInput[];
}
